module.exports = __webpack_public_path__ + "static/media/app01_ch02.9ba81d4e.png";